(ns nosco.lazy
  (:require-macros nosco.lazy)
  (:require
   [goog.object]
   ["react" :as React]
   [shadow.lazy]
   [shadow.esm :as esm]))

;; this is a slightly modified version of
;; https://code.thheller.com/blog/shadow-cljs/2019/03/03/code-splitting-clojurescript.html
;; the lazy-component macro will emit a simple
;; (nosco.lazy/lazy-component* (shadow.lazy/loadable some.qualified/symbol))

(defn- lazy-component-esm [loadable-name]
  (React/lazy
   (fn []
      ;; React lazy expects a promise, that returns an ES6 module with a React Component as default export
     (-> (esm/load-by-name loadable-name)

         (.then
          (fn [root-el-f]
            (if-not js/goog.DEBUG
                ;; in production mode, just do that
              #js {:default (root-el-f)}
                ;; in dev mode, we need wrap the loaded component one
                ;; extra level so live-reload actually works since React
                ;; will keep a reference to the initially loaded fn and
                ;; won't update it
              #js {:default (React/forwardRef
                             (fn lazy-loaded [props maybe-ref]
                               (if maybe-ref
                                 (let [props' (goog.object/clone props)]
                                   (goog.object/set props' "ref" maybe-ref)
                                   (React/createElement (root-el-f) props' (.-children props)))
                                 (React/createElement (root-el-f) props (.-children props)))))})))))))

(defn- lazy-component-browser [loadable]
  (React/lazy
   (fn []
      ;; React lazy expects a promise, that returns an ES6 module with a React Component as default export
     (-> (shadow.lazy/load loadable)

         (.then
          (fn [root-el]
            (if-not js/goog.DEBUG
                ;; in production mode, just do that
              #js {:default root-el}
                ;; in dev mode, we need wrap the loaded component one
                ;; extra level so live-reload actually works since React
                ;; will keep a reference to the initially loaded fn and
                ;; won't update it
              #js {:default (React/forwardRef
                             (fn lazy-loaded [props maybe-ref]
                               (if maybe-ref
                                 (let [props' (goog.object/clone props)]
                                   (goog.object/set props' "ref" maybe-ref)
                                   (React/createElement @loadable props' (.-children props)))
                                 (React/createElement @loadable props (.-children props)))))})))))))

(goog-define USE-ESM-LAZY true)

(defn lazy-component* [loadable-name shadow-loadable]
  (if USE-ESM-LAZY
    (lazy-component-esm loadable-name)
    (lazy-component-browser shadow-loadable)))
